import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectieSeriiComponent } from './directie-serii.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { EditPrefixComponent } from './edit-prefix/edit-prefix.component';
import { AddSerieComponent } from './add-serie/add-serie.component';
import { MassAssignStatusComponent } from './mass-assign-status/mass-assign-status.component';
import { AlocareResponsabileCompartimentComponent } from './alocare-responsabile-compartiment/alocare-responsabile-compartiment.component';
import { AddAlocareResponsabileCompartimentComponent } from './alocare-responsabile-compartiment/add-alocare-responsabile-compartiment/add-alocare-responsabile-compartiment.component';

@NgModule({
    declarations: [
        DirectieSeriiComponent,
        EditPrefixComponent,
        AddSerieComponent,
        MassAssignStatusComponent,
        AlocareResponsabileCompartimentComponent,
        AddAlocareResponsabileCompartimentComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        FormsModule
    ],
    exports: [DirectieSeriiComponent]
})
export class DirectieSeriiModule { }
